import { getDirection } from '@repo/i18n';
import { I18nProvider, useLocale } from '@repo/i18n/react';
import { DirectionProvider } from '@repo/ui/direction';
import type { ReactNode } from 'react';
export const LocaleRoot = ({ children }: { children: ReactNode }) => {
  const locale = useLocale();
  return (
    <I18nProvider>
      <DirectionProvider dir={getDirection(locale)}>{children}</DirectionProvider>
    </I18nProvider>
  );
};
